module.exports = __webpack_public_path__ + "asset/image-icon-image-aff2af5657ab6cfd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/event-edit-modal/image/icon-image.svg
// module id = hypg
// module chunks = 0